import { alpha } from '@mui/material/styles';

import {
  ReadinessCheckSeverity,
  ReadinessCheckStatus,
} from '../../../../../readiness/readinessChecks.constants';

const HIGHLIGHT_BG_ALPHA = 0.06;

const rowStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  padding: '14px 0',
  borderBottom: ({ palette }) => `1px solid ${palette.border.input}`,
  '&:last-of-type': {
    borderBottom: 'none',
  },
};

export const getRowStyles = isHighlighted => ({
  ...rowStyles,
  ...(isHighlighted && {
    padding: '14px 12px',
    borderRadius: '6px',
    backgroundColor: ({ palette }) => alpha(palette.error.main, HIGHLIGHT_BG_ALPHA),
  }),
});

export const getMarkColor = ({ status, severity }) => {
  if (status === ReadinessCheckStatus.PASS) {
    return ({ palette }) => palette.success.main;
  }

  if (severity === ReadinessCheckSeverity.HARD) {
    return ({ palette }) => palette.error.main;
  }

  return ({ palette }) => palette.warning.main;
};

export const markStyles = markColor => ({
  color: markColor,
  display: 'flex',
  flexShrink: 0,
  marginTop: '2px',
});

export const contentStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flex: 1,
  minWidth: 0,
};

export const titleRowStyles = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '8px',
};

export const descriptionStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const fixButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  flexShrink: 0,
  padding: '2px 4px',
  minWidth: 'auto',
  color: ({ palette }) => palette.error.main,
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
};
